import React from 'react'
import NavigationLayout from 'layouts/Navigation'
import Layout from './layouts'

const CollectionPage = () => (
  <NavigationLayout dataApp='collection'>
    <Layout />
  </NavigationLayout>
)

export default CollectionPage
